/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { EventField, RelatedContentModal } from '@molecules';
import { showConfirm } from '@utils/modal';
import { NO_MARGIN_BOTTOM } from '@constants';

const CisBulkUnApproveEventModal = ({ visible, hide, onSubmit }) => {
  const onOk = (event) => {
    onSubmit(event);
  };
  const bulkUpdateUsers = async (event) => {
    showConfirm({
      okText: 'CONFIRM',
      onOk: () => onOk(event),
      title: 'Are you sure you want to bulk unapprove all users?',
      content: 'for ( ' + event.eventIdWa + ' ) THIS CAN NOT BE UNDONE!',
    });
  };

  return (
    <RelatedContentModal
      visible={visible}
      hide={hide}
      title="Select an event for bulk unaproval"
      subtitle="Search event by name"
      okText="UNAPPROVE"
      onSubmit={({ event }) => bulkUpdateUsers(event)}
    >
      <EventField
        label="Choose an event:"
        name="event"
        extra={null}
        wrapperCol={{ span: 24 }}
        style={NO_MARGIN_BOTTOM}
        rules={[{ required: true, message: 'Event is required' }]}
        showIdList
      />
    </RelatedContentModal>
  );
};

export default CisBulkUnApproveEventModal;
